import React from "react";
import ClientListContent from "./ClientListContent";

const ClientList = () => {
	return <ClientListContent />;
};

export default ClientList;
